const getTimezoneOffset = (): number => {
    const currentYear = new Date().getFullYear()
    return Math.max(
        parseFloat(new Date(currentYear, 0, 1).getTimezoneOffset() as unknown as string),
        parseFloat(new Date(currentYear, 6, 1).getTimezoneOffset() as unknown as string),
    )
}

export default getTimezoneOffset;